import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const PHOTOS_STEP_SKELETON_ITEMS_COUNT = 3

export const PhotosStepSkeleton = () => (
  <div className={s.grid}>
    {Array.from({ length: PHOTOS_STEP_SKELETON_ITEMS_COUNT }).map(
      (_, index) => (
        <Skeleton
          key={index}
          className={s.item}
        />
      ),
    )}
  </div>
)
